export enum RENTT_FE_BE_MAPPING_FIELD {
    id = 'id',
    userName = 'userName',
    firstName = 'firstName',
    lastName = 'lastName',
    companyName = 'companyName',
    email = 'email',
    access = 'access',
    role = 'role',
    site = 'site',

}
export class RenTT {
    id: number;
    userName: string;
    firstName: string;
    lastName: string;
    companyName: string;
    email: string;
    access: string;
    role: string;
    site: string;

    constructor(params: any = {}, parsed: boolean = true) {

        if (parsed) {
            this.parseFromResp(params);
        } else {
            this.id = params.id;
            this.userName = params.userName;
            this.firstName = params.firstName;
            this.lastName = (params.lastName || '');
            this.companyName = params.companyName;
            this.email = params.email;
            this.access = params.access;
            this.role = params.role;
            this.site = params.site;
        }
    }

    parseFromResp(respObject: any = {}) {
        this.id = respObject[RENTT_FE_BE_MAPPING_FIELD.id];
        this.userName = respObject[RENTT_FE_BE_MAPPING_FIELD.userName];
        this.firstName = respObject[RENTT_FE_BE_MAPPING_FIELD.firstName];
        this.lastName = respObject[RENTT_FE_BE_MAPPING_FIELD.lastName];
        this.companyName = respObject[RENTT_FE_BE_MAPPING_FIELD.companyName];
        this.email = respObject[RENTT_FE_BE_MAPPING_FIELD.email];
        this.access = respObject[RENTT_FE_BE_MAPPING_FIELD.access];
        this.role = respObject[RENTT_FE_BE_MAPPING_FIELD.role];
        this.site = respObject[RENTT_FE_BE_MAPPING_FIELD.site];
        return this;
    }

    convertToReqBody() {
        const body = {};
        body[RENTT_FE_BE_MAPPING_FIELD.id] = this.id;
        body[RENTT_FE_BE_MAPPING_FIELD.firstName] = this.firstName || '';
        body[RENTT_FE_BE_MAPPING_FIELD.userName] = this.userName || '';
        body[RENTT_FE_BE_MAPPING_FIELD.lastName] = this.lastName || '';
        body[RENTT_FE_BE_MAPPING_FIELD.companyName] = this.companyName || '';
        body[RENTT_FE_BE_MAPPING_FIELD.email] = this.email || '';
        body[RENTT_FE_BE_MAPPING_FIELD.access] = this.access || '';
        body[RENTT_FE_BE_MAPPING_FIELD.role] = this.role || '';
        body[RENTT_FE_BE_MAPPING_FIELD.site] = this.site || '';
        return body;

    }
}
